import { put, select, takeLatest } from 'redux-saga/effects'

import { callApi } from '@/shared/tools/apiSagaHelperV2'
import { selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import {
  addOfferCutPeriod,
  removeOfferCutPeriod,
  updateOfferCutPeriod,
} from '@/containers/OrganizationsManagement/organizationsManagementSlice'

export const offerCutPeriodsActions = {
  CREATE: 'OFFERS/CUT_PERIODS/CREATE',
  UPDATE: 'OFFERS/CUT_PERIODS/UPDATE',
  DELETE: 'OFFERS/CUT_PERIODS/DELETE',
}

interface ExtraRoutes {
  offerCutPeriods?: {
    list?: string
    create?: string
    update?: string
    delete?: string
  }
}

interface CutPeriodPayload {
  id?: number | string
  offer_id?: number | string
  team_id: number | string
  cut_start: string
  cut_end?: string | null
}

interface CreateAction {
  payload: CutPeriodPayload
  enqueue?: any
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

interface UpdateAction extends CreateAction {
  cutPeriodId: number | string
}

interface DeleteAction {
  cutPeriodId: number | string
  enqueue?: any
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

function* createOfferCutPeriodSaga(action: CreateAction): Generator {
  const { payload, enqueue, onSuccess, onError } = action
  try {
    const { offerCutPeriods } = (yield select(selectExtraRoutesAuthData)) as ExtraRoutes
    if (!offerCutPeriods?.create) return

    const data = (yield callApi({
      endpoint: offerCutPeriods.create,
      method: 'POST',
      payload: payload as any,
      enqueue,
      showErrorSnackbar: true,
    })) as CutPeriodPayload | undefined

    if (data) {
      yield put(addOfferCutPeriod(data))
      if (onSuccess) onSuccess()
    }
  } catch (error) {
    if (onError) onError(error)
  }
}

function* updateOfferCutPeriodSaga(action: UpdateAction): Generator {
  const { cutPeriodId, payload, enqueue, onSuccess, onError } = action
  try {
    const { offerCutPeriods } = (yield select(selectExtraRoutesAuthData)) as ExtraRoutes
    if (!offerCutPeriods?.update) return

    const data = (yield callApi({
      endpoint: offerCutPeriods.update,
      method: 'PUT',
      payload: payload as any,
      asteriskReplacement: String(cutPeriodId) as any,
      enqueue,
      showErrorSnackbar: true,
    })) as CutPeriodPayload | undefined

    if (data) {
      yield put(updateOfferCutPeriod(data))
      if (onSuccess) onSuccess()
    }
  } catch (error) {
    if (onError) onError(error)
  }
}

function* deleteOfferCutPeriodSaga(action: DeleteAction): Generator {
  const { cutPeriodId, enqueue, onSuccess, onError } = action
  try {
    const { offerCutPeriods } = (yield select(selectExtraRoutesAuthData)) as ExtraRoutes
    if (!offerCutPeriods?.delete) return

    yield callApi({
      endpoint: offerCutPeriods.delete,
      method: 'DELETE',
      asteriskReplacement: String(cutPeriodId) as any,
      enqueue,
      showErrorSnackbar: true,
    })

    yield put(removeOfferCutPeriod(cutPeriodId))
    if (onSuccess) onSuccess()
  } catch (error) {
    if (onError) onError(error)
  }
}

export default function* offerCutPeriodsSagas() {
  yield takeLatest(offerCutPeriodsActions.CREATE, createOfferCutPeriodSaga as any)
  yield takeLatest(offerCutPeriodsActions.UPDATE, updateOfferCutPeriodSaga as any)
  yield takeLatest(offerCutPeriodsActions.DELETE, deleteOfferCutPeriodSaga as any)
}
